import { render, staticRenderFns } from "./AccreditationContact.vue?vue&type=template&id=0906cd34&"
import script from "./AccreditationContact.vue?vue&type=script&lang=js&"
export * from "./AccreditationContact.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports